import {
  FacebookIcon,
  FacebookShareButton,
  HatenaIcon,
  HatenaShareButton,
  PinterestIcon,
  PinterestShareButton,
  TwitterIcon,
  TwitterShareButton
} from 'react-share'

import React from 'react'

const ShareButton = ({title, url, media}) => {
  return (
    <div className='flex'>
      <div id="btn_facebook_top" className='pr-4 click__share'>
        <FacebookShareButton url={url}>
          <FacebookIcon size={42} round />
        </FacebookShareButton>
      </div>

      <div id="btn_twitter_top" className='pr-4 click__share'>
        <TwitterShareButton title={title} url={url} via={'takeshi_du'} >
          <TwitterIcon size={42} round />
        </TwitterShareButton>
      </div>

      <div id="btn_hatena_top" className='pr-4 click__share'>
        <HatenaShareButton url={url} >
          <HatenaIcon size={42} round />
        </HatenaShareButton>
      </div>

      <div id="btn_pin_top" className='pr-4 click__share'>
        <PinterestShareButton url={url} media={media} >
          <PinterestIcon size={42} round />
        </PinterestShareButton>
      </div>
    </div>
  )
}

export default ShareButton